// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root___yFPo","buttons":"Footer_buttons__S4u3u"};